var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('v-table',{ref:"table",attrs:{"url":"/api/v1/customerProfile","filter":[
      {
        name: 'customer'
      },
      {
        name: 'whereIn',
        attributes: [{ column: 'user_id', values: _vm.onlineIds }]
      }
    ],"attributes":[
      {
        name: 'Benutzer',
        type: 'LinkProfileCell'
      },
      {
        attribute: 'last_seen_at',
        name: 'letzter Seitenaufruf (wo)'
      },
      {
        attribute: 'last_seen_on',
        name: 'letzter Seitenaufruf (wann)',
        type: 'DateTimeCell'
      },
      {
        attribute: 'last_login_at',
        name: 'letzter Login',
        type: 'DateTimeCell'
      },
      {
        attribute: 'last_login_at',
        name: 'Online seit',
        type: 'MinutesSinceCell'
      }
    ]}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }